'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-b2d9610a.js');
var React = require('react');
var index = require('./index-fccd5f88.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');
var Typography = require('./Typography-8468e4cf.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".SubTabs_module_visuallyHidden__461f4b95 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.SubTabs_module_youtubeVideo__461f4b95 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.SubTabs_module_mdsTabs__461f4b95 {\n  width: 100%;\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsWrapper__461f4b95 {\n  position: relative;\n  overflow: hidden;\n  overflow-x: auto;\n  white-space: nowrap;\n  padding: 14px;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n  border-top: 2px solid #d4d4d8;\n  border-bottom: 2px solid #d4d4d8;\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsList__461f4b95 {\n  max-width: fit-content;\n  margin: 0 auto;\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsList__461f4b95::-webkit-scrollbar {\n  display: none;\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsList__461f4b95 .SubTabs_module_TabsButton__461f4b95 {\n  position: relative;\n  color: #444f6b;\n  cursor: pointer;\n  background-color: #ffffff;\n  outline: none;\n  border: transparent;\n  border-bottom: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  margin-right: 14px;\n  text-transform: uppercase;\n  border-radius: 4px;\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsList__461f4b95 .SubTabs_module_TabsButton__461f4b95.SubTabs_module_TabsButtonActive__461f4b95 {\n  color: #444f6b;\n  background-color: #ffffff;\n  position: relative;\n  text-decoration: underline;\n  text-transform: uppercase;\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsList__461f4b95 .SubTabs_module_TabsButton__461f4b95:hover {\n  text-decoration: underline;\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsList__461f4b95 .SubTabs_module_TabsButton__461f4b95:focus-visible {\n  text-decoration: underline;\n  box-shadow: inset 0px 0px 0px 2px #fff, 0px 0px 0px 3px #7f5f9c, 0px 0px 0px 6px #fff, 1px 8px 16px rgba(25, 25, 25, 0.2);\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsPanels__461f4b95 {\n  width: 100%;\n  position: relative;\n  padding: 24px;\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsPanels__461f4b95 .SubTabs_module_TabsPanel__461f4b95 {\n  width: 100%;\n  display: none;\n}\n.SubTabs_module_mdsTabs__461f4b95 .SubTabs_module_TabsPanels__461f4b95 .SubTabs_module_TabsPanel__461f4b95.SubTabs_module_TabsPanelActive__461f4b95 {\n  display: block;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Organisms/Tabs/SubTabs/SubTabs.module.scss");
var modules_5d01a02e = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"SubTabs_module_visuallyHidden__461f4b95","youtubeVideo":"SubTabs_module_youtubeVideo__461f4b95","mdsTabs":"SubTabs_module_mdsTabs__461f4b95","TabsWrapper":"SubTabs_module_TabsWrapper__461f4b95","TabsList":"SubTabs_module_TabsList__461f4b95","TabsButton":"SubTabs_module_TabsButton__461f4b95","TabsButtonActive":"SubTabs_module_TabsButtonActive__461f4b95","TabsPanels":"SubTabs_module_TabsPanels__461f4b95","TabsPanel":"SubTabs_module_TabsPanel__461f4b95","TabsPanelActive":"SubTabs_module_TabsPanelActive__461f4b95"};

var SubTabs = function SubTabs(_ref) {
  var tabsItems = _ref.tabsItems,
    defaultActive = _ref.defaultActive,
    extraClass = _ref.extraClass,
    tabOnClick = _ref.tabOnClick;
  var _useState = React.useState(defaultActive !== null && defaultActive !== void 0 ? defaultActive : 0),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  var handleClick = function handleClick(index) {
    return setSelectedIndex(index);
  };

  // to store reference to the tab element
  var tabRefs = React.useRef({});

  // Selected tab update helper
  var setIndex = function setIndex(index) {
    var tab = tabRefs.current[index];
    if (tab) {
      // focus() will call the state setter
      // to display the associated tabpanel
      tab.focus();
    }
  };

  // onKeyDown handler for tab elements
  var onKeyDown = function onKeyDown(event) {
    var count = tabsItems.length;
    var nextTab = function nextTab() {
      return setIndex((selectedIndex + 1) % count);
    };
    var prevTab = function prevTab() {
      return setIndex((selectedIndex - 1 + count) % count);
    };
    var firstTab = function firstTab() {
      return setIndex(0);
    };
    var lastTab = function lastTab() {
      return setIndex(count - 1);
    };
    var keyMap = {
      ArrowRight: nextTab,
      ArrowLeft: prevTab,
      Home: firstTab,
      End: lastTab
    };
    var action = keyMap[event.key];
    if (action) {
      event.preventDefault();
      action();
    }
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_5d01a02e.mdsTabs, extraClass].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_5d01a02e.TabsWrapper
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_5d01a02e.TabsList,
    role: "tablist",
    "aria-orientation": "horizontal"
  }, tabsItems.map(function (item, index) {
    return item.hideTab != true ? /*#__PURE__*/React__default["default"].createElement("button", {
      // key={index}
      key: "tabsButton-".concat(index),
      ref: function ref(element) {
        return tabRefs.current[index] = element;
      },
      id: "tabsButton-".concat(item.id),
      "aria-selected": selectedIndex === index ? true : false,
      "aria-controls": "tabPanel-".concat(item.id),
      role: "tab",
      tabIndex: selectedIndex === index ? 0 : -1,
      onClick: function onClick(e) {
        var _item$action;
        handleClick(index);
        tabOnClick === null || tabOnClick === void 0 || tabOnClick(e, item);
        (_item$action = item.action) === null || _item$action === void 0 || _item$action.call(item);
      },
      onFocus: function onFocus() {
        return setSelectedIndex(index);
      },
      onKeyDown: onKeyDown,
      className: [modules_5d01a02e.TabsButton, selectedIndex === index ? modules_5d01a02e.TabsButtonActive : null].join(" ")
    }, /*#__PURE__*/React__default["default"].createElement(Typography.Span, {
      fontSize: "S",
      bold: true
    }, item.label)) : null;
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_5d01a02e.TabsPanels
  }, tabsItems.map(function (item, index) {
    return item.hideTab != true ? /*#__PURE__*/React__default["default"].createElement("div", {
      key: "tabPanel-".concat(index),
      hidden: selectedIndex !== index,
      id: "tabPanel-".concat(item.id),
      "aria-labelledby": "tabsButton-".concat(item.id),
      role: "tabpanel",
      className: [modules_5d01a02e.TabsPanel, selectedIndex === index ? modules_5d01a02e.TabsPanelActive : null].join(" ")
    }, item.content) : null;
  })));
};
SubTabs.propTypes = {
  extraClass: index.propTypes.exports.string,
  defaultActive: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  tabOnClick: index.propTypes.exports.func,
  tabsItems: index.propTypes.exports.arrayOf(index.propTypes.exports.shape({
    id: index.propTypes.exports.number.isRequired,
    label: index.propTypes.exports.string,
    iconName: index.propTypes.exports.string,
    action: index.propTypes.exports.func,
    hideTab: index.propTypes.exports.bool
  }))
};

exports.SubTabs = SubTabs;
